module.exports = "/_next/static/images/3a845c2b81407f68aa53076dac9a4d5e-nuis_light_heart.svg";